import React from 'react';
import PropTypes from 'prop-types';
import {
  withStyles,
  Icon,
  List,
  ListItem,
  Avatar,
  ListItemText,
  ListItemSecondaryAction,
  Checkbox,
} from '@material-ui/core';
import { connect } from 'react-redux';
import { getStatuses } from '@pingum/app-state-management/status/actions';
import Property from '../../../widgets/Property';
import FieldDisplayMessage from '../../../widgets/FieldDisplayMessage';
import propTypes from '../../../../utils/propTypes';
import styles from './styles';

export const getUpdatedStatusWithSelections = (statuses, ids) => {
  const data = [];
  for (let i = 0; i < statuses.length; i += 1) {
    const status = statuses[i];
    if (ids.filter((id) => id === status.id).length > 0) {
      status.selected = true;
    } else {
      status.selected = false;
    }
    data.push(status);
  }
  return data;
};

export class FilterStatusComponent extends React.Component {
  constructor(props) {
    super(props);

    const searchEvents = this.props.overrideSearchEvents || this.props.searchEvents;

    this.state = { searchEvents };

    if (props.statuses.length === 0) {
      this.props.getStatuses(false);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.overrideSearchEvents
      && JSON.stringify(prevProps.overrideSearchEvents.statusIds)
      !== JSON.stringify(this.props.overrideSearchEvents.statusIds)) {
      this.setState({ searchEvents: this.props.overrideSearchEvents });
    }
  }

  handleToggleStatus = (id) => {
    this.setState((prevState) => {
      const newSearchEvents = prevState.searchEvents;
      if (!this.isStatusSelected(id)) {
        newSearchEvents.statusIds = newSearchEvents.statusIds
          ? prevState.searchEvents.statusIds.concat(id)
          : [id];
      } else {
        newSearchEvents.statusIds = prevState.searchEvents.statusIds
          .filter((statusId) => statusId !== id);
      }
      return { searchEvents: newSearchEvents };
    }, () => {
      this.props.updateSearchEventsState(this.state.searchEvents.statusIds, 'statusIds');
    });
  }

  isStatusSelected = (id) => this.state.searchEvents.statusIds && this.state.searchEvents.statusIds.indexOf(id) >= 0

  render() {
    const {
      classes,
      statuses,
    } = this.props;
    const updatedStatuses
      = getUpdatedStatusWithSelections(statuses, this.state.searchEvents.statusIds || []);
    return (
      <div>
        <div className={classes.section}>
          <Property label="Statuses" disableGutters>
            {
            updatedStatuses.filter((updatedStatus) => !updatedStatus.archived)
              .sort((a, b) => a.statusOrder - b.statusOrder).length > 0
              ? (
                <List className={classes.statusList}>
                  {
                    updatedStatuses.filter((updatedStatus) => !updatedStatus.archived)
                      .sort((a, b) => a.statusOrder - b.statusOrder).map((status) => (
                        <ListItem
                          key={status.id}
                          dense
                          button
                          className={classes.listItem}
                          onClick={() => { this.handleToggleStatus(status.id); }}
                        >
                          <Avatar
                            alt={status.name}
                            style={{
                              color: status.iconColor,
                              width: 30,
                              height: 30,
                            }}
                          >
                            <Icon style={{ fontSize: 18 }}>
                              {status.icon}
                            </Icon>
                          </Avatar>
                          <ListItemText primary={status.name} classes={{ root: classes.listItemText }} />
                          <ListItemSecondaryAction classes={{ root: classes.listItemAction }}>
                            <Checkbox
                              checked={status.selected}
                              onChange={() => { this.handleToggleStatus(status.id); }}
                              color="primary"
                            />
                          </ListItemSecondaryAction>
                        </ListItem>
                      ))
                  }
                </List>
              )
              : (
                <FieldDisplayMessage
                  title="No Statuses defined for your organization"
                  subTitle="Admins can create statuses from the Event Settings page"
                  icon="info_outlined"
                />
              )
          }
          </Property>
        </div>
      </div>
    );
  }
}

FilterStatusComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  searchEvents: PropTypes.shape(propTypes.searchEvents).isRequired,
  getStatuses: PropTypes.func.isRequired,
  statuses: PropTypes.arrayOf(propTypes.statusShape),
  updateSearchEventsState: PropTypes.func.isRequired,
  overrideSearchEvents: PropTypes.object,
};

FilterStatusComponent.defaultProps = {
  statuses: [],
  overrideSearchEvents: null,
};

export const mapStateToProps = (state) => ({
  searchEvents: { ...state.dashboard.currentFilterDashboard.dashboardData },
  statuses: state.status.statuses,
});

export const mapDispatchToProps
  = (dispatch) => ({ getStatuses: (returnArchived) => dispatch(getStatuses(returnArchived)) });

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(FilterStatusComponent));
